import { render, staticRenderFns } from "./Copywriter.vue?vue&type=template&id=72d6bb99&"
import script from "./Copywriter.vue?vue&type=script&lang=js&"
export * from "./Copywriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports